module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multiselect', {
    attrs: {
      "value": _vm.value,
      "select-label": "",
      "options": _vm.suggestions,
      "custom-label": _vm.label,
      "track-by": "id",
      "loading": _vm.isLoading,
      "placeholder": _vm.placeholder,
      "allow-empty": true,
      "optionsLimit": 10
    },
    on: {
      "input": _vm.update,
      "search-change": _vm.search
    }
  }, [_vm._t("noResult", null, {
    slot: "noResult"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4116e6a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/multi-select.vue
// module id = 100
// module chunks = 0 1